var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileGenericIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#282828"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2812 18.375C27.2812 17.2266 26.625 16.1602 25.6406 15.5449C24.6152 14.9707 23.3438 14.9707 22.3594 15.5449C21.334 16.1602 20.7188 17.2266 20.7188 18.375C20.7188 19.5645 21.334 20.6309 22.3594 21.2461C23.3438 21.8203 24.6152 21.8203 25.6406 21.2461C26.625 20.6309 27.2812 19.5645 27.2812 18.375ZM18.75 18.375C18.75 16.5293 19.7344 14.8066 21.375 13.8633C22.9746 12.9199 24.9844 12.9199 26.625 13.8633C28.2246 14.8066 29.25 16.5293 29.25 18.375C29.25 20.2617 28.2246 21.9844 26.625 22.9277C24.9844 23.8711 22.9746 23.8711 21.375 22.9277C19.7344 21.9844 18.75 20.2617 18.75 18.375ZM16.8223 32.1562H31.1367C30.7676 29.5723 28.5527 27.5625 25.8457 27.5625H22.1133C19.4062 27.5625 17.1914 29.5723 16.8223 32.1562ZM14.8125 32.9355C14.8125 28.875 18.0527 25.5938 22.1133 25.5938H25.8457C29.9062 25.5938 33.1875 28.875 33.1875 32.9355C33.1875 33.5918 32.6133 34.125 31.957 34.125H16.002C15.3457 34.125 14.8125 33.5918 14.8125 32.9355Z",
    fill: "#AEAEB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGenericIcon);
export default __webpack_public_path__ + "static/media/profile_generic_icon.ccdacf8d3efc5118f9b4187fbbfb3f50.svg";
export { ForwardRef as ReactComponent };